import { render } from "./Size.vue?vue&type=template&id=3131338a&scoped=true"
import script from "./Size.vue?vue&type=script&lang=js"
export * from "./Size.vue?vue&type=script&lang=js"

import "./Size.vue?vue&type=style&index=0&id=3131338a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3131338a"]])

export default __exports__